import i18n from '@/lang/i18n'

export default [
  {
    path: '/admin/apply/shop/category',
    name: 'ShopCategory',
    component: () => import('@/views/apply/shop/category'),
    meta: {
      title: i18n.t('router.shop.category_manage'),
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/shop/product',
    name: 'ShopProduct',
    component: () => import('@/views/apply/shop/product'),
    meta: {
      title: i18n.t('router.shop.product_manage'),
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/shop/product/detail',
    name: 'ShopProductDetail',
    component: () => import('@/views/apply/shop/product/detail'),
    meta: {
      title: i18n.t('router.shop.product_detail'),
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/shop/delivery_template',
    name: 'ShopDeliveryTemplate',
    component: () => import('@/views/apply/shop/delivery_template'),
    meta: {
      title: i18n.t('router.shop.delivery_template'),
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/shop/delivery_template/detail',
    name: 'ShopDeliveryTemplateDetail',
    component: () => import('@/views/apply/shop/delivery_template_detail'),
    meta: {
      title: i18n.t('router.shop.delivery_template_detail'),
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/shop/custom_form',
    name: 'ShopCustomForm',
    component: () => import('@/views/apply/shop/custom_form'),
    meta: {
      title: i18n.t('router.shop.custom_form'),
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/shop/custom_form/detail',
    name: 'ShopCustomFormDetail',
    component: () => import('@/views/apply/shop/custom_form_detail'),
    meta: {
      title: i18n.t('router.shop.custom_form_detail'),
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/shop/product_tag',
    name: 'ShopProductTag',
    component: () => import('@/views/apply/shop/product_tag'),
    meta: {
      title: i18n.t('router.shop.product_tag'),
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/shop/return_address',
    name: 'ShopReturnAddress',
    component: () => import('@/views/apply/shop/return_address'),
    meta: {
      title: i18n.t('router.shop.return_address'),
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/shop/return_address/detail',
    name: 'ShopReturnAddressDetail',
    component: () => import('@/views/apply/shop/return_address_detail'),
    meta: {
      title: i18n.t('router.shop.return_address_detail'),
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/shop/full_reduction',
    name: 'ShopFullReduction',
    component: () => import('@/views/apply/shop/full_reduction'),
    meta: {
      title: i18n.t('router.shop.full_reduction'),
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/shop/full_reduction/detail',
    name: 'ShopFullReductionDetail',
    component: () => import('@/views/apply/shop/full_reduction_detail'),
    meta: {
      title: i18n.t('router.shop.full_reduction_detail'),
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/shop/pickup_point',
    name: 'ShopPickupPoint',
    component: () => import('@/views/apply/shop/pickup_point'),
    meta: {
      title: i18n.t('router.shop.pickup_point_manage'),
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/shop/pickup_point/detail',
    name: 'ShopPickupPointDetail',
    component: () => import('@/views/apply/shop/pickup_point_detail'),
    meta: {
      title: i18n.t('router.shop.pickup_point_detail'),
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/shop/pickup_verifier',
    name: 'ShopPickupVerifier',
    component: () => import('@/views/apply/shop/pickup_verifier'),
    meta: {
      title: i18n.t('router.shop.verifier_manage'),
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/shop/pickup_verifier/detail',
    name: 'ShopPickupVerifierDetail',
    component: () => import('@/views/apply/shop/pickup_verifier_detail'),
    meta: {
      title: i18n.t('router.shop.verifier_detail'),
      headType: 0,
      auth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/apply/shop.js